export default function FileNamesCard() {
  return (
    <div className="ad-card">
      <div className="ad-card-header">
        <div className="ad-card-title">File Names</div>
      </div>

      <div className="ad-empty">
        <div className="ad-empty-title">
          Select a company to load files
        </div>
      </div>
    </div>
  );
}